import http from '../../../services/http-common';

class BudgetingService {
    getBudgetingViewtable() {
    return http.get(`/Budgeting/db/Viewtable`);
    }
    getBudgetingForList() {
    return http.get(`/Budgeting/sp/list`);
    }
    
    getBudgetingDetailForList(EntryID ,BudgetCategoryID) {
    return http.get(`/Budgeting/detailsp/list/${EntryID}/${BudgetCategoryID}`);
    }
    upperCalculationSummary(data) {
        return http.post(`/Budgeting/UpperCalculation/Summary`,data);
    }
    calculationSummary(data) {
        return http.post(`/Budgeting/Calculation/Summary`,data);
    }
    gridSumSummary(data) {
        return http.post(`/Budgeting/GridSum/Summary`,data);
    }
    yarnDetailSummary(data) {
return http.post(`/Budgeting/YarnDetail/Summary`,data);
        }
    updateWithDetail(data){
        return http.put(`/Budgeting/db/updateWithDetail`,data);

    }
    addDetail(data){
        return http.post(`/Budgeting/db/addDetail`,data);

    }
    addWithDetail(data){
        return http.post(`/Budgeting/dbAdd/addWithDetail`,data);

    }
    updateBudgetingMain(data){
        return http.put(`/Budgeting/db/updateBudgetingMain`,data);

    }
    








    delete(id) {
        return http.delete(`/Budgeting/db/delete/${id}`);
        }


  



 
   
}

export default new BudgetingService();